import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SafetyList from './safety-list';
import SafetyForms from './safety-forms';
import { paths } from '../../../routes';

const Safety = () => (
  <Switch>
    <Route path={paths.safety.path} exact>
      <SafetyList />
    </Route>
    <Route path={paths.newSafety.path}>
      <SafetyForms />
    </Route>
    <Route path={paths.safety.path + '/:reportId'}>
      <SafetyForms />
    </Route>
  </Switch>
);

export default Safety;
